export default __webpack_public_path__ + "static/media/photo--sm--wheel-12.92e6df99.jpg";